import AntMainLayout from '../AntMainLayout';
import React, { Component } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

export default (props) => (
    <BrowserRouter>
        <AntMainLayout navigateItems={props.appNavigation} appInfo={props.appInfo} appAssets={props.appAssets} userMenuItems={props.userMenuItems}>
            <Routes>
                {props.appRoutes.map((item) => (
                    <Route
                        exact
                        key={item.path}
                        path={item.path}
                        element={item.component}
                        loader={async (request, params) => {
                            var user = localStorage.getItem(cs.System_Code + '-session-info');
                            user = JSON.parse(user);

                            var session = {
                                // history: pr.history,
                                user: user,
                                app: {
                                    info: props.appInfo,
                                    assets: props.appAssets,
                                    config: props.appConfig
                                },
                                page: {
                                    url: request.url,
                                    path: request.path,
                                    params: params
                                }
                            };

                            return {
                                ...params,
                                session: session
                            };
                        }}
                    />
                ))}
                <Route to={'/home'} />
            </Routes>
            {/* <AntMainFooter>
        Copyright © 2020 by dev@ante.vn.
        <br />
        Hệ thống quản trị bán hàng Ant eCom
      </AntMainFooter> */}
        </AntMainLayout>
    </BrowserRouter>
);
